import * as prodConfig from './prodConfig';
import * as localConfig from './localConfig';

export default process.env.NODE_ENV === 'production' ? prodConfig : localConfig;
